import { useMemo } from 'react'

const defaultOptions = {
  //   style: 'currency',
  //   currency: 'USD',
  //   symbol: '$d',
  //   code: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  currencySign: 'accounting',
  addParanthesesForNegative: true,
  //   currencyDisplay: 'none',
}

export default function useNumberFormatter(options = {}) {
  // Stringify so a fresh `{}` literal on every render doesn't rebuild the
  // Intl.NumberFormat each time (and doesn't churn dependent memos/effects).
  const optionsKey = JSON.stringify(options)

  const combinedOptions = useMemo(
    () => ({
      ...defaultOptions,
      ...options,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [optionsKey],
  )

  const formatter = useMemo(() => {
    return new Intl.NumberFormat(undefined, { ...combinedOptions })
  }, [combinedOptions])

  const formatNumber = (value) => {
    // Never surface "NaN" in the UI. Empty/undefined/garbage → blank.
    const num = typeof value === 'number' ? value : Number(value)
    if (!Number.isFinite(num)) {
      return value === '' || value === null || value === undefined ? '' : '0.00'
    }

    const formattedValue = formatter.format(num)
    if (num < 0 && combinedOptions.addParanthesesForNegative) {
      return `(${formattedValue})`
    }
    return formattedValue
  }

  return formatNumber
}
